/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PreferredTrainingFormat;

(function (PreferredTrainingFormat) {
  PreferredTrainingFormat["IN_PERSON_TRAINING"] = "in_person_training";
  PreferredTrainingFormat["ONLINE_TRAINING"] = "online_training";
  PreferredTrainingFormat["BOTH"] = "both";
  PreferredTrainingFormat["NOT_CONFIRMED"] = "not_confirmed";
  PreferredTrainingFormat["NOT_REQUIRED"] = "not_required";
})(PreferredTrainingFormat || (PreferredTrainingFormat = {}));